import { useContext } from 'react';

import { RedirectContext, type RedirectContextType } from './redirect-context';

export const useRedirectContext = (): RedirectContextType => {
  const context = useContext(RedirectContext);

  if (!context) {
    throw new Error('useRedirectContext must be used within a RedirectProvider');
  }

  return context;
};
